/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartPyramid = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 .756 3.951 7.939 2.665 5.33.003.002 3.998 8.012H1.383l3-6.012h-.001l1-2v-.001l2.665-5.331zm5.38 15.27H6.617l-2.001 4.012h14.767zm-2.999-5.999H9.618l-2 3.999h8.761zM12 5.244l-1.386 2.783h2.771z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartPyramid as ChartPyramid };
